import type { FaireProductEntity } from "../../entity_types/product";

export const p_3xmkfvryze: FaireProductEntity = {
  token: "p_3xmkfvryze",
  type: "product",
  name: "Feisty Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/f631028d0294cb412a145d34a68998617718afd5dd1560ee1ce627e2e654df18.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cedbeab77701ca75095defe9b523a445c40b8790fa3a84184bf6584425603a81.jpeg",
    "https://cdn.faire.com/fastly/a85320b6e5beac679132c5c60eaf16a87c6db36c836b6696f2fb5067f0e41540.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/53254c031ddbdeb26c2ee88dd03d2e7c4d13808054134222f1c6d9869c3c564c.jpeg",
    "https://cdn.faire.com/fastly/050528847db484807c61ce73cee24ff6bc44536d6f1e10ed12196c8d376bff7e.jpeg"
  ],
  priceDollars: 6.75,
  description: "Socks for people who didn’t start it — but will absolutely finish it.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:18.546Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
